/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      if ( $( '.related-slider' ).length ) {
        $( '.related-slider__slider' ).find( '.product' ).each( function( index, element ) {
          $( element ).addClass( 'splide__slide' );
        } );
        $( '.related-slider' ).each( function( index, element ) {
          const relatedSlider = new Splide( element, {
            gap: '2rem',
            perPage: 3,
            perMove: 1,
            pagination: false,
            type: 'loop',
            speed: 800,
            arrows: true,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } );
          relatedSlider.on( 'overflow', function( isOverflow ) {
            if ( isOverflow ) {
              // Enough slides
            } else {
              relatedSlider.options = {
                drag: isOverflow,
              };
            }
          } );
          relatedSlider.mount( {} );
        } );
      }
      if ( $( '#splide-gallery' ).length && $( '#splide-gallery__nav' ).length ) {
        const gallery = new Splide( '#splide-gallery', {
          type: 'loop',
          perPage: 1,
          arrows: false,
          pagination: false,
        } );

        const galleryNav = new Splide( '#splide-gallery__nav', {
          type: 'slide',
          fixedWidth: '6.25rem',
          arrows: false,
          pagination: false,
          isNavigation: true,
          gap: '12px',
        } );

        galleryNav.on( 'overflow', function( isOverflow ) {
          galleryNav.go( 0 );
          galleryNav.options = {
            drag: isOverflow,
            clones: isOverflow ? undefined : 0,
          };
        } );

        gallery.sync( galleryNav );
        gallery.mount();
        galleryNav.mount();
      }
      // increment quantity
      $( 'body' ).on( 'click', '.increment-qty', function( e ) {
        e.preventDefault();
        const qtyInput = $( this ).siblings( 'input.qty' );
        const currentVal = parseInt( qtyInput.val() );
        const maxVal = parseInt( qtyInput.attr( 'max' ) );
        if ( !isNaN( maxVal ) && currentVal >= maxVal ) {
          return;
        }
        qtyInput.val( currentVal + 1 ).trigger( 'change' );
      } );
      // decrement quantity
      $( 'body' ).on( 'click', '.decrement-qty', function( e ) {
        e.preventDefault();
        const qtyInput = $( this ).siblings( 'input.qty' );
        const currentVal = parseInt( qtyInput.val() );
        const minVal = parseInt( qtyInput.attr( 'min' ) );
        if ( currentVal <= minVal ) {
          return;
        }
        qtyInput.val( currentVal - 1 ).trigger( 'change' );
      } );
      $( 'form#shop-sidebar-filter input' ).on( 'change', function() {
        $( 'form#shop-sidebar-filter' ).submit();
      } );
      $( '.filter-pill button' ).on( 'click', function( e ) {
        e.preventDefault();

        const filter = $( this ).attr( 'id' );
        $( `form#shop-sidebar-filter input[value="${filter}"]` ).trigger( 'click' );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'woocommerce', COMPONENT );
} )( app );
